import { render, staticRenderFns } from "./IlluMedal.vue?vue&type=template&id=cccb4456&"
import script from "./IlluMedal.vue?vue&type=script&lang=js&"
export * from "./IlluMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports